<template>
  <div class="page-top-section" :class="[ $route.name !== 'landing' ? 'not-landing' : '' ]">
    <div class="section-indicator" v-if="false">
      <span></span>
      <span></span>
      <span></span>
      <!-- <div style="color:gray;">{{ scrollPos }}</div> -->
    </div>

    <div class="container-wrapper" v-if="$route.name === 'landing'">
      <div v-if="loading === false" data-aos="fade-in" data-aos-once="true" style="height:100%;">
        <div class="slick-wrapper" data-aos="fade-in" data-aos-once="true" style="height:100%;">
          <slick ref="slick" :options="slickOptions">
            <div class="item-wrapper" v-for="item in items" v-bind:key="item.title" :caption="item.title" :href="item.image.path" :src="item.image.path" style="background-color:black;">
              <div class="item-image item-image-desktop" v-if="isDesktop" nopin="nopin" :style="{ 'background-image': 'url(' + item.image.path + ')' }" />
              <div class="item-image item-image-mobile" v-else-if="item.image_mobile" nopin="nopin" :style="{ 'background-image': 'url(' + item.image_mobile.path + ')' }" />
              <div class="item-image item-image-desktop" v-else nopin="nopin" :style="{ 'background-image': 'url(' + item.image.path + ')' }" />
                <div class="item-slogan">
                  <div-container>
                    <div class="slogan">
                    <!-- <img v-if="isDesktop" src="../assets/slogan.svg" width="200" class="img-responsive" />
                    <img v-else src="../assets/slogan_m.svg" width="300" class="img-responsive" /> -->
                    <h1>
                      Come BBQ
                    </h1><br />
                    <h1>
                      With The Boss
                    </h1>
                  </div>
                </div-container>
              </div>
            </div>
            <!-- </lightbox> -->
          </slick>
        </div>
      </div>
    </div>

    <section class="scroll-down" v-if="false">
      <a @click="$scrollTo('#section-about', { offset: -30 })">
        <div class="content">
          <div class="circle">
            <i class="fa fa-angle-double-down"></i>
          </div>
        </div>
      </a>
    </section>

    <section class="arrow-down" v-if="false">
      <a @click="$scrollTo('#section-about', { offset: -30 })"><span></span></a>
    </section>

    <slot></slot>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/Site'

import DivContainer from '@/components/DivContainer'
import Slick from 'vue-slick'
import Lightbox from 'vue-lightbox'

export default {
  name: 'landing',
  components: {
    DivContainer,
    Slick,
    Lightbox
  },
  data () {
    return {
      isDesktop: true,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: true,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 1008,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }, {
            // 768 = tablet (not break yet)
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }
        ]
      },
      items: [],
      itemsEnded: false,
      error: undefined,
      loading: true,
      scrollPos: 0
    }
  },
  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  watch: {
  },
  created () {
    // console.log('created TopSection.vue')
  },
  mounted () {
    // console.log('mounted TopSection.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    next () {
      if (this.$refs.slick) {
        this.$refs.slick.next()
      }
    },
    prev () {
      if (this.$refs.slick) {
        this.$refs.slick.prev()
      }
    },
    reInit () {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick()
      }
    },
    getItems: function (onComplete) {
      this.loading = true
      this.error = undefined
      Site.carousel()
      .then((data) => {
        // console.log(data)
        onComplete(data)
        this.$nextTick(function () {
          this.reInit()
        })
        this.reInit()
        this.loading = false
      })
      .catch((error) => {
        this.error = error
        this.error = 'Unable to load, please kindly refresh the page.'
        this.loading = false
      })
    },
    refresh: function () {
      this.getItems((items) => {
        this.items = items
      })
    },
    renderYtSubscribeButton: function (channel) {
      /* global gapi */
      var container = document.getElementById('yt-button-container-render')
      var options = {
        'channel': channel,
        'layout': 'full'
      }
      gapi.ytsubscribe.render(container, options)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/slick.scss";

.page-top-section {
  $top-section-height-wrap: 92%;
  $top-section-height: 100%;

  height: $top-section-height-wrap; // noc: full height
  position: relative;

  &.not-landing {
    height: auto; // noc: zero height
  }

  .container-wrapper {
    max-height: $top-section-height; // noc: full height
    height: $top-section-height; // noc: full height
    background-color: $color-gray;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

    .item-wrapper {
      .item-slogan {
        .slogan {
          h1 {
            color: $color-gray-mid;
            font-family: $font-family-poster;
            text-transform: uppercase;
          }
        }
      }
    }
  }

  .section-indicator {
    position: fixed;
    left: 0px;
    top: 50%;

    span {
      display: block;
      clear: both;
      overflow: hidden;
      width: 9px;
      height: 9px;
      border-radius: 5px;
      background-color: $color-white;
      margin: 10px;
      border: 1px solid $color-gray;

      &.is-active {
        background-color: $color-gray;
      }
    }
  }

  // slick

  .slick-wrapper-outer {
    height: $top-section-height;
    overflow-x: visible;
    overflow-y: visible;
    position: relative;

    img {
      height: $top-section-height;
      width: auto;
      max-height: 100%;
      max-width: 500%;
      position: absolute;
      // z-index: 1;
      bottom: 10%;
      left: -2%;

      // landscape mobile
      @media screen and (max-width: $mobile) and (orientation: landscape) {
        height: auto;
        width: 100%;
        max-height: 400%;
        max-width: 100%;
        left: 20%;
        bottom: 0%;
      }

      @media screen and (min-width: $tablet) {
        left: 8%;
        bottom: 0%;
      }
    }
  }

  .slick-wrapper {
    height: $top-section-height !important; // noc: full height

    .slick {
      height: $top-section-height; // noc: full height
    }

    .slick-slider {
      width: 100%;
      height: $top-section-height;

      .slick-track, .slick-list {
        width: 100%;
        height: $top-section-height;
      }
    }

    .slick-initialized {
      .slick-slide {
        width: 100%;
        height: $top-section-height !important;

        div {
          // width: 100%;
          height: $top-section-height !important;

          div.item-wrapper {
            width: 100%;
            height: $top-section-height !important;
            background-color: $color-gray;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            overflow-y: hidden;

            div.item-slogan {
              width: 100%;
              position: absolute;
              top: 45%;

              @media screen and (min-width: $desktop) {
                top: 38%;
              }

              div.slogan {
                padding-left: 15px;
                padding-right: 15px;

                @media screen and (min-width: $desktop) {
                  padding-left: 50px;
                  padding-right: 50px;
                }

                h1 {
                  display: inline-block;
                  color: white;
                  font-size: 2.8em;
                  line-height: 1.2em;
                  // border-bottom: 4px solid white;
                  // text-decoration: underline;
                  font-family: $font-family-title;
                  letter-spacing: 0;

                  @media screen and (min-width: $desktop) {
                    font-size: 4.4em;
                  }
                }
              }

              // img {
              //   margin-left: 0;
              //   width: 50%;
              //
              //   @media screen and (min-width: $desktop) {
              //     width: 50%;
              //   }
              // }
            }

            img, .item-image {
              margin: auto;

              &.item-image-desktop,
              &.item-image-mobile {
                width: 100%; // noc: full width
                height: 100%; // noc: full height
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
              }
            }
          }
        }
      }
    }
  }
}

.landing-logo {
  width: 100px;
  margin: 15px;
  margin-bottom: 0;
  vertical-align: top;
  @media screen and (min-width: $tablet) {
    width: auto;
    margin: 0;
  }
}

.subscribe-wrapper {
  padding-top: 10px;
  padding-left: 0px;
  margin: 15px;
  margin-top: 0px;
  // display: inline-block;

  @media screen and (min-width: $mobile-min) {
  }

  @media screen and (max-width: $mobile) and (orientation: landscape) {
    // display: block;
    margin-top: 0px;
  }

  @media screen and (min-width: $tablet) {
    // display: block;
    padding-left: 6%;
    margin: 0;
    margin-top: 20px;
  }

  @media screen and (min-width: $desktop) {
    padding-left: 7%;
  }

  i.fa {
    color: $color-white;
    margin-top: 0;
    @media screen and (min-width: $tablet) {
      margin-top: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// TopSection.vue?cce6b05c